import { useFilters } from "../../Common/Hooks/useFilters"

export interface SpiritCountLinkProps {
	spiritCount: number
}

export function SpiritCountLink(props: SpiritCountLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className='filter' href='#' onClick={(e) => {
			e.preventDefault()
			addFilter('spiritCounts', `${props.spiritCount}`)
		}}>
			{props.spiritCount}
		</a>
	)
}
